import { RegionIdMap } from '@/view-models/region'

/**
 * 各地區對應的餐酒 category ID
 */
export const FUNKI_FOOD_WINE_CATEGORY_MAP: Record<number, number> = {
  [RegionIdMap.Taipei]: 8,
  [RegionIdMap.Taichung]: 21,
  // [RegionIdMap.HONG_KONG]: -1,
  [RegionIdMap.TAINAN_KAOHSIUNG]: 153,
  [RegionIdMap.OKINAWA]: 106,
  [RegionIdMap.TOKYO]: 10771,
  [RegionIdMap.KualaLumpur]: 113,
  [RegionIdMap.PENANG]: 10898,
  [RegionIdMap.KANSAI]: 141,
  [RegionIdMap.Bangkok]: 11498,
  // [RegionIdMap.CHIANGMAI]: -1,
  [RegionIdMap.SAPPORO]: 10772,
}

/**
 * 檢查指定的地區和 category ID 是否為餐酒分類
 */
export const isFoodWineCategory = (regionId: number, categoryId: number): boolean => {
  const expectedCategoryId = FUNKI_FOOD_WINE_CATEGORY_MAP[regionId]
  return expectedCategoryId === categoryId
}
